import { Component, OnInit } from '@angular/core';
import { VersionControllerService } from '../../api/notices';
import { Observable } from 'rxjs';

import generatedLicenseData from './licenses/generated-licenses.json';
import staticLicenseData from './licenses/static-licenses.json';

interface License {
  name: string;
  licenseType: string;
  author: string;
}
@Component({
  selector: 'app-lizenzen',
  templateUrl: './lizenzen.component.html',
  styleUrls: ['./lizenzen.component.scss'],
})
export class LizenzenComponent implements OnInit {
  licenses: License[] = [
    ...(staticLicenseData as License[]),
    ...(generatedLicenseData as License[]),
  ];
  resyVersion$: Observable<string>;

  constructor(private versionControllerService: VersionControllerService) {
  }

  ngOnInit() {
    this.resyVersion$ = this.versionControllerService.getResyVersion();
  }
}
